import React from "react";
import styled from "styled-components";

const TitleBox = styled.div`
    width: auto;
    font-size: 5em;
    font-weight: bold;
    text-align: center;
    color: #004076;

    @media all and (max-width: 479px) {
        font-size: 2.5em;
    }
`;

function Title () {
    return (
        <TitleBox>POKE-DICT</TitleBox>
    );
};

export default Title;